/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { AskUserQuestionsResponseRequest } from "./AskUserQuestionsResponseRequest";
import type { Contexts } from "./Contexts";
import type { RxRenewalSendMessageRequest } from "./RxRenewalSendMessageRequest";
import type { TextSendMessageRequest } from "./TextSendMessageRequest";

/**
 * Request schema for sending a message in a conversation via the
 * /chat/{conversation_id} endpoint
 */
export interface SendMessageRequest {
  message:
    | TextSendMessageRequest
    | RxRenewalSendMessageRequest
    | AskUserQuestionsResponseRequest;
  initial_agent?: string | null;
  contexts?: Contexts | null;
  attachment_ids?: string[] | null;
}
